import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination, Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

import slide_image_1 from "../images/IMG_3216.JPG";
import slide_image_2 from "../images/IMG_3377.JPG";
import slide_image_3 from "../images/IMG_3371.JPG";
import slide_image_4 from "../images/IMG_3375.JPG";
import slide_image_5 from "../images/IMG_3329.JPG";
import slide_image_6 from "../images/IMG_3367.JPG";
import slide_image_7 from "../images/IMG_3191.JPG";

import "../css/gallery.css";

const Gallery = () => {
  return (
    <section className="gallery-section">
      <div className="gallery-container">
        <div className="section-header">
        <h2 className="section-subtitle">EnergyX Africa Experience</h2>
        <h1 className="section-title">
            <span className="title-highlight">Our Visual</span> Journey At A Glance
          </h1>
          <div className="divider"></div>
          <p className="section-description">
          Explore our breathrough industry initiative connecting Southern Africa's just energy transition future
          </p>
        </div>

        <Swiper
          effect={"coverflow"}
          grabCursor={true}
          centeredSlides={true}
          loop={true}
          slidesPerView={"auto"}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          coverflowEffect={{
            rotate: 5,
            stretch: 0,
            depth: 150,
            modifier: 2,
            slideShadows: true,
          }}
          pagination={{ 
            el: ".gallery-pagination", 
            clickable: true,
            dynamicBullets: true
          }}
          navigation={{
            nextEl: ".gallery-button-next",
            prevEl: ".gallery-button-prev",
          }}
          modules={[EffectCoverflow, Pagination, Navigation, Autoplay]}
          className="gallery-swiper"
          breakpoints={{
            // Mobile
            320: {
              slidesPerView: 1,
              spaceBetween: 20
            },
            // Tablets
            768: {
              slidesPerView: 2,
              spaceBetween: 30
            },
            // Small laptops (13-14")
            1024: {
              slidesPerView: 3,
              spaceBetween: 30,
              coverflowEffect: {
                depth: 100,
                modifier: 1.8
              }
            },
            // Medium laptops (15-16") and MacBooks
            1280: {
              slidesPerView: 3,
              spaceBetween: 40,
              coverflowEffect: {
                depth: 120,
                modifier: 2
              }
            },
            // Large laptops
            1440: {
              slidesPerView: 3,
              spaceBetween: 50,
              coverflowEffect: {
                depth: 150,
                modifier: 2.2
              }
            }
          }}
        >
          {[slide_image_1, slide_image_2, slide_image_3, slide_image_4, slide_image_5, slide_image_6, slide_image_7].map((image, index) => (
            <SwiperSlide key={index}>
              <div className="slide-container">
                <img src={image} alt={`Gallery ${index + 1}`} className="slide-image" />
                <div className="image-overlay">
                  <span className="image-number">{index + 1}</span>
                </div>
              </div>
            </SwiperSlide>
          ))}

          <div className="gallery-controls">
            <div className="gallery-button-prev">
              <FaArrowLeft className="control-icon" />
            </div>
            <div className="gallery-pagination"></div>
            <div className="gallery-button-next">
              <FaArrowRight className="control-icon" />
            </div>
          </div>
        </Swiper>
      </div>
    </section>
  );
};

export default Gallery;